import { FETCH_ALL_VOLUNTEER_SKILLS } from '../../constants/actionTypes'

export default (vlnVolunteerSkills = [], action) => {
    switch (action.type) {
        case FETCH_ALL_VOLUNTEER_SKILLS:
            return action.payload;
        default:
            return vlnVolunteerSkills;
    }
}